import React, { useState, useEffect } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import { useLocation, useHistory } from "react-router-dom";
const logoimage = `https://hirepros.co.uk` + "/staticlogo.png";
const bgimg = `https://hirepros.co.uk` + "/bgimg.jpg";

const IframeCode = () => {
  const history = useHistory();
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [JobsData, setJobsData] = useState([]);
  const [totalJobs, setTotalJobs] = useState(0);
  const [jobsPerPage] = useState(5);
  const location = useLocation(); // Jobs per page
  const searchprm = new URLSearchParams(location.search);
  const token = searchprm.get("authtoken"); // Extract the token from the query params
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const domainPath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
  const domainpath = "https://api.hirepros.co.uk";
  const [customStyles, setCustomStyles] = useState({
    jobBorderColor: "#003366",
    jobCountColor: "#003366",
    jobBackgroundColor: "#ffffff",
    jobTextColor: "#003366",
    jobHoverBackgroundColor: "#f0f8ff",
    buttonBackgroundColor: "#003366",
    buttonprevBackgroundColor: "#003366",
    buttonnextBackgroundColor: "#ffffff",
    buttonTextColor: "#ffffff",
    paginationbuttonTextColor: "#ffffff",
    buttonprevTextColor: "#ffffff",
    buttonnextTextColor: "#003366",
    paginationbuttonBackgroundColor: "#ffa500",
    buttonHoverBackgroundColor: "#0056b3",
    buttonHoverTextColor: "#ffffff",
    buttonprevHoverBackgroundColor: "#0056b3",
    buttonprevHoverTextColor: "#ffffff",
    buttonnextHoverBackgroundColor: "#0056b3",
    buttonnextHoverTextColor: "#ffffff",
    jobTitleColor: "#003366", // Job title color
    companyNameColor: "#666666", // Company name color
    locationColor: "#777777", // Location color
    salaryColor: "#4b8700", // Salary color
    jobTypeColor: "#003366", // Job type color (Full-Time, Part-Time)
    paginationButtonColor: "#ffffff", // Pagination buttons color
    paginationButtonHoverColor: "#003366",
    companyNameBackgroundColor: "#fff", // Company name background color
    locationBackgroundColor: "#f1f4f7", // Location background color
    salaryBackgroundColor: "#f1f4f7", // Salary background color
    jobTypeBackgroundColor: "#fff8eb",
    jobTitleFontSize: 15, // Job title font size
    companyNameFontSize: 16, // Company name font size
    locationFontSize: 14, // Location font size
    salaryFontSize: 16, // Salary font size
    jobTypeFontSize: 14, // Job type font size
    paginationButtonFontSize: 14,
    jobBorderRadius: 10,
  });
  console.log(token, "token");

  useEffect(() => {
    if (!token) {
      console.error("Authorization token is missing from URL!");
      return;
    }
    fetchJobs();
  }, [currentPage, token]);

  const fetchUserSettingsByToken = async () => {
    try {
      const response = await fetch(
        `${domainPath}/api/employer/get-settings-by-token`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token, // Pass the token in headers
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch user settings.");
      }

      const data = await response.json();
      setCustomStyles(data.customStyles);
      console.log("User settings fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching user settings:", error);
      //alert("An error occurred while fetching user settings: " + error.message);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUserSettingsByToken();
    }
  }, [token]);
  // Fetch jobs from API
  const fetchJobs = async () => {
    try {
      const response = await axios.get(`${domainpath}/api/v1/jobs`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      const { jobsData, totalPages, totalRecords } = response.data;

      setJobs(jobsData || []);
      setJobsData(response.data); // Set jobs or an empty array
      setFilteredJobs(jobsData || []); // For search filtering
      setTotalPages(totalPages || 1);
      setTotalRecords(totalRecords || 0);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  // Handle search input
  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.get(`${domainpath}/api/v1/search-jobs`, {
        params: {
          title: search, // Limit jobs per page
        },
        headers: {
          Authorization: `${token}`, // Include the authorization token
        },
      });

      const { jobsData, totalRecords, totalPages } = response.data;

      // Update state with API response
      setFilteredJobs(jobsData || []);
      setJobs(jobsData || []);
      setTotalRecords(totalRecords || 0);
      setTotalPages(totalPages || 1);
      JobsData.totalRecords = totalRecords;
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const getVisiblePages = () => {
    const visiblePages = [];
    const maxVisibleButtons = 5; // Number of page buttons to show

    if (totalPages <= maxVisibleButtons) {
      // Show all page numbers if total pages is less than or equal to max visible buttons
      for (let i = 1; i <= totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Show limited number of page buttons
      let startPage = Math.max(
        1,
        currentPage - Math.floor(maxVisibleButtons / 2)
      );
      let endPage = startPage + maxVisibleButtons - 1;

      // Adjust if near the beginning
      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisibleButtons + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      // Add ellipsis for skipped ranges
      if (startPage > 1) {
        visiblePages.unshift("...");
        visiblePages.unshift(1);
      }
      if (endPage < totalPages) {
        visiblePages.push("...");
        visiblePages.push(totalPages);
      }
    }

    return visiblePages;
  };

  const visiblePages = getVisiblePages();
  const handleClear = (e) => {
    e.preventDefault();
    setSearch("");
    setFilteredJobs(jobs);
    JobsData.totalRecords = jobs.length;
  };

  return (
    <div className="">
      {/* Search Bar */}

      {/* Job List */}
      <div className="container mx-auto p-4 iframesec">
        <section className="hrp-container hrp-section-2 ">
          <div className="hrp-sub-section">
            <div className="joblist container m-auto ">
              <input
                type="text"
                className="border border-gray-300 p-2 rounded w-full bg-white shadow-lg"
                placeholder="Search job titles..."
                value={search}
                id="jobsearchform"
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  backdropFilter: "blur(8px)",
                  padding: "17px 20px", // Add slight blur effect for aesthetic
                }}
              />

              {filteredJobs.length > 0 && filteredJobs != [] ? (
                <>
                  <div className="joblistheader pt-4">
                    <div className="joblistheader-first">
                      <h1
                        style={{
                          color: customStyles.jobCountColor,
                        }}
                      >
                        {JobsData?.totalRecords} jobs found
                      </h1>
                    </div>
                    <div className="joblistheader-second">
                      <button
                        style={{
                          backgroundColor: customStyles.buttonBackgroundColor,
                          color: customStyles.buttonTextColor,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonHoverBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonHoverTextColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonBackgroundColor;
                          e.target.style.color = customStyles.buttonTextColor;
                        }}
                        onClick={handleSearch}
                        className="joblist-btnclear"
                      >
                        Search
                      </button>
                      <button
                        style={{
                          backgroundColor: customStyles.buttonBackgroundColor,
                          color: customStyles.buttonTextColor,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonHoverBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonHoverTextColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonBackgroundColor;
                          e.target.style.color = customStyles.buttonTextColor;
                        }}
                        className="joblist-btnclear"
                        onClick={(e) => handleClear(e)}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                  <div>
                    <div className="joblistbody space-y-4">
                      {filteredJobs?.map((job, index) => (
                        <div
                          className="joblist-card border rounded-lg p-4 lg:flex md:flex items-center justify-between hover:shadow-lg transition-shadow"
                          key={index}
                          style={{
                            borderColor: customStyles.jobBorderColor,
                            backgroundColor: customStyles.jobBackgroundColor,

                            color: customStyles.jobTextColor,

                            // color: customStyles.jobTextColor,
                            borderRadius: `${customStyles.jobBorderRadius}px`,
                          }}
                        >
                          <div className="joblist-cardimg">
                            <img
                              src={
                                job.company.logo.startsWith("http")
                                  ? job.company.logo
                                  : job.company.logo.includes("uploads")
                                  ? `${domainpath}${job.company.logo}`
                                  : `${domainpath}/uploads/${job.company.logo}`
                              }
                              alt={`${job.company.name} Logo`}
                              onClick={() =>
                                history.push(
                                  `https://hirepros.co.uk/companies/${job.company.name}`
                                )
                              }
                              className="cursor-pointer"
                              // style={{ width: "120px" }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = logoimage; // Replace with a default logo
                              }}
                            />
                            {!job?.company?.logo && (
                              <svg
                                width="62"
                                height="62"
                                viewBox="0 0 62 62"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M30.9999 31.0001L43.9166 18.0834C43.9166 10.9495 38.1338 5.16675 30.9999 5.16675C23.866 5.16675 18.0833 10.9495 18.0833 18.0834L30.9999 31.0001Z"
                                  stroke="#003366"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M31 31.0002L18.0833 43.9168C10.9494 43.9168 5.16663 38.134 5.16663 31.0002C5.16663 23.8663 10.9494 18.0835 18.0833 18.0835L31 31.0002ZM31 31.0002L43.9166 18.0835C51.0505 18.0835 56.8333 23.8663 56.8333 31.0002C56.8333 38.134 51.0505 43.9168 43.9166 43.9168L31 31.0002Z"
                                  stroke="#003366"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M30.9999 56.8333C38.1338 56.8333 43.9166 51.0505 43.9166 43.9167L30.9999 31L18.0833 43.9167C18.0833 51.0505 23.866 56.8333 30.9999 56.8333Z"
                                  stroke="#003366"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </div>
                          <div className="joblist-carddetail">
                            <div className="flex">
                              <span
                                className="briefjobtype"
                                style={{
                                  color: customStyles.jobTypeColor,
                                  backgroundColor:
                                    customStyles.jobTypeBackgroundColor,
                                  fontSize: `${customStyles.jobTypeFontSize}px`,
                                }}
                              >
                                <FeatherIcon icon="briefcase" />
                                {job?.jobType[0]}
                              </span>
                            </div>{" "}
                            <a
                              href={`https://hirepros.co.uk/jobs/${
                                job?._id
                              }?job=${job?.title.replace(
                                /\s+/g,
                                "-"
                              )}&company=${job?.company?.name.replace(
                                /\s+/g,
                                "-"
                              )}`}
                            >
                              <h1>{job.title}</h1>
                            </a>
                            <p
                              className="cursor-pointer"
                              style={{
                                color: customStyles.companyNameColor,
                                backgroundColor:
                                  customStyles.companyNameBackgroundColor,
                                fontSize: `${customStyles.companyNameFontSize}px`,
                              }}
                              // onClick={() =>
                              //   history.push(`/companies/${job.company.name}`)
                              // }
                            >
                              {job?.company?.name}
                            </p>
                            <div className="joblist-cardinner">
                              <div
                                className="joblist-cardinnerdetail"
                                style={{
                                  color: customStyles.jobTitleColor,
                                  backgroundColor:
                                    customStyles.jobTitleBackgroundColor,
                                  fontSize: `${customStyles.jobTitleFontSize}px`,
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.9997 15H10.9997C10.7345 15 10.4802 14.8947 10.2926 14.7071C10.1051 14.5196 9.99973 14.2653 9.99973 14V11C9.99973 10.7348 10.1051 10.4805 10.2926 10.2929C10.4802 10.1054 10.7345 10 10.9997 10H13.9997C14.2649 10 14.5193 10.1054 14.7068 10.2929C14.8944 10.4805 14.9997 10.7348 14.9997 11V14C14.9997 14.2653 14.8944 14.5196 14.7068 14.7071C14.5193 14.8947 14.2649 15 13.9997 15ZM10.9997 11V14H13.9997V11H10.9997ZM8.99973 13H5.99973C5.60203 12.9996 5.22073 12.8415 4.93951 12.5603C4.65829 12.279 4.50013 11.8977 4.49973 11.5V9.50004H5.49973V11.5C5.49973 11.6326 5.55241 11.7598 5.64618 11.8536C5.73994 11.9474 5.86712 12 5.99973 12H8.99973V13ZM12.9997 9.00004H11.9997V7.50004C11.9997 7.36743 11.9471 7.24025 11.8533 7.14648C11.7595 7.05272 11.6323 7.00004 11.4997 7.00004H8.99973V6.00004H11.4997C11.8974 6.00043 12.2787 6.1586 12.56 6.43982C12.8412 6.72103 12.9993 7.10233 12.9997 7.50004V9.00004ZM7.49973 9.00004C7.41256 9.00008 7.32689 8.97732 7.25123 8.93404L4.99973 7.64404L2.74823 8.93404C2.66379 8.98239 2.56707 9.00505 2.46993 8.99925C2.3728 8.99344 2.27947 8.95942 2.20139 8.90135C2.1233 8.84328 2.06386 8.76368 2.03035 8.67233C1.99684 8.58097 1.99072 8.48182 2.01273 8.38704L2.54323 6.10104L1.13423 4.59104C1.07265 4.52496 1.03011 4.44343 1.01115 4.35512C0.99218 4.26681 0.997492 4.17501 1.02652 4.08947C1.05554 4.00394 1.1072 3.92786 1.17599 3.86933C1.24478 3.81079 1.32815 3.77199 1.41723 3.75704L3.51723 3.40604L4.55023 1.28104C4.59086 1.19762 4.65391 1.12716 4.7323 1.07753C4.8107 1.0279 4.90136 1.00107 4.99414 1.00003C5.08692 0.998993 5.17816 1.02379 5.25765 1.07165C5.33714 1.11952 5.40174 1.18855 5.44423 1.27104L6.54623 3.40604L8.58473 3.75704C8.6736 3.77235 8.75668 3.81142 8.82516 3.87011C8.89363 3.92879 8.94497 4.0049 8.97372 4.09038C9.00246 4.17586 9.00756 4.26752 8.98846 4.35566C8.96936 4.44379 8.92678 4.52513 8.86523 4.59104L7.45623 6.10104L7.98623 8.38704C8.00323 8.46031 8.00348 8.53647 7.98696 8.60985C7.97044 8.68324 7.93757 8.75195 7.89081 8.81086C7.84405 8.86978 7.7846 8.91739 7.71689 8.95014C7.64918 8.9829 7.57495 8.99995 7.49973 9.00004ZM4.99973 6.50004C4.99973 6.50004 5.17123 6.59004 5.24823 6.63454L6.75323 7.49654L6.36123 5.80804L7.50223 4.58554L5.88573 4.30704L5.01323 2.61604L4.19123 4.30704L2.50073 4.58954L3.63773 5.80804L3.24573 7.49654L4.75073 6.63454C4.82873 6.59004 4.99973 6.50004 4.99973 6.50004Z"
                                    fill="#0085FF"
                                  />
                                </svg>
                                <span>{job?.title}</span>
                              </div>{" "}
                              {(job?.location?.address &&
                                job.location.address !== "N/A") ||
                              (job?.location?.city &&
                                job.location.city !== "N/A") ||
                              (job?.location?.area &&
                                job.location.area !== "N/A") ? (
                                <div className="joblist-cardinnerdetail">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M9.00028 15.8914L9.54114 15.282C10.1549 14.5791 10.7069 13.9123 11.198 13.278L11.6034 12.7431C13.2963 10.4623 14.1431 8.65197 14.1431 7.31397C14.1431 4.45797 11.8409 2.14282 9.00028 2.14282C6.15971 2.14282 3.85742 4.45797 3.85742 7.31397C3.85742 8.65197 4.70428 10.4623 6.39714 12.7431L6.80257 13.278C7.50323 14.1757 8.23628 15.0469 9.00028 15.8914Z"
                                      stroke="#FF0000"
                                      strokeWidth="1.14286"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9.00028 9.42854C10.1837 9.42854 11.1431 8.46915 11.1431 7.28568C11.1431 6.10221 10.1837 5.14282 9.00028 5.14282C7.81681 5.14282 6.85742 6.10221 6.85742 7.28568C6.85742 8.46915 7.81681 9.42854 9.00028 9.42854Z"
                                      stroke="#FF0000"
                                      strokeWidth="1.14286"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>

                                  <span
                                    style={{
                                      color: customStyles.locationColor,
                                      backgroundColor:
                                        customStyles.locationBackgroundColor,
                                      fontSize: `${customStyles.locationFontSize}px`,
                                    }}
                                  >
                                    {job?.location?.address &&
                                    job.location.address !== "N/A"
                                      ? job.location.address
                                      : `${
                                          job.location.city !== "N/A"
                                            ? job.location.city
                                            : ""
                                        } ${
                                          job.location.area !== "N/A"
                                            ? job.location.area
                                            : ""
                                        }`.trim()}
                                  </span>
                                </div>
                              ) : null}
                              {job?.pay?.rateType && (
                                <div className="joblist-cardinnerdetail">
                                  {job?.pay.rateType !== "" &&
                                  job?.pay.rateType !== null &&
                                  job?.pay.minimum !== "Not specified" &&
                                  job?.pay.minimum !== "NaN" &&
                                  job?.pay.maximum !== "NaN" ? (
                                    <>
                                      <div
                                        className="salery-inner"
                                        style={{
                                          color: customStyles.salaryColor,
                                          backgroundColor:
                                            customStyles.salaryBackgroundColor,
                                          fontSize: `${customStyles.salaryFontSize}px`,
                                        }}
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 16 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.9493 7.83333H12.1533C11.204 7.83333 10.4993 8.53933 10.4993 9.33333C10.4993 10.1273 11.204 10.8333 12.1527 10.8333H13.9647C14.102 10.8247 14.1613 10.732 14.166 10.676V7.99066C14.1613 7.93466 14.102 7.842 13.9647 7.834L13.9493 7.83333ZM13.9 6.83333C13.944 6.83333 13.9867 6.83333 14.0267 6.83599C14.6067 6.87133 15.1207 7.30933 15.164 7.92133C15.1667 7.96133 15.1667 8.00466 15.1667 8.04466V10.622C15.1667 10.662 15.1667 10.7053 15.164 10.7453C15.1207 11.3573 14.6067 11.7953 14.026 11.8313C13.9867 11.8333 13.944 11.8333 13.8993 11.8333H12.154C10.724 11.8333 9.5 10.748 9.5 9.33333C9.5 7.91866 10.724 6.83333 12.1533 6.83333H13.8887H13.9Z"
                                            fill="#4B8700"
                                          />
                                          <path
                                            d="M12.6663 9.33334C12.6663 9.51015 12.5961 9.67972 12.4711 9.80474C12.3461 9.92977 12.1765 10 11.9997 10C11.8229 10 11.6533 9.92977 11.5283 9.80474C11.4032 9.67972 11.333 9.51015 11.333 9.33334C11.333 9.15653 11.4032 8.98696 11.5283 8.86193C11.6533 8.73691 11.8229 8.66667 11.9997 8.66667C12.1765 8.66667 12.3461 8.73691 12.4711 8.86193C12.5961 8.98696 12.6663 9.15653 12.6663 9.33334Z"
                                            fill="#4B8700"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.8997 6.83334C14.0909 6.82611 14.2813 6.86259 14.4563 6.94C14.385 5.86934 14.1883 5.044 13.5723 4.42734C13.073 3.92867 12.4403 3.70734 11.659 3.602L11.631 3.59867C11.624 3.59338 11.6169 3.58827 11.6097 3.58334L9.11901 1.932C8.68698 1.65005 8.18223 1.49992 7.66634 1.49992C7.15045 1.49992 6.64571 1.65005 6.21367 1.932L3.72367 3.58334C3.71621 3.58826 3.70887 3.59337 3.70167 3.59867L3.67367 3.602C2.89234 3.70734 2.25967 3.92867 1.76034 4.42734C1.26167 4.92667 1.04034 5.55934 0.935008 6.34067C0.833008 7.10067 0.833008 8.07067 0.833008 9.296V9.37067C0.833008 10.596 0.833008 11.5667 0.935008 12.326C1.04034 13.1073 1.26167 13.74 1.76034 14.2393C2.25967 14.738 2.89234 14.9593 3.67367 15.0647C4.43367 15.1667 5.40367 15.1667 6.62901 15.1667H8.70367C9.92901 15.1667 10.8997 15.1667 11.659 15.0647C12.4403 14.9593 13.073 14.738 13.5723 14.2393C14.1883 13.6227 14.385 12.7973 14.4563 11.726C14.3217 11.786 14.1763 11.822 14.0257 11.8313C13.9863 11.8333 13.9437 11.8333 13.899 11.8333H13.445C13.369 12.728 13.1977 13.2 12.865 13.532C12.583 13.814 12.1963 13.9833 11.5257 14.0733C10.841 14.1653 9.93767 14.1667 8.66634 14.1667H6.66634C5.39501 14.1667 4.49234 14.1653 3.80634 14.0733C3.13634 13.9833 2.74967 13.814 2.46767 13.532C2.18567 13.25 2.01634 12.8633 1.92634 12.1927C1.83434 11.508 1.83301 10.6047 1.83301 9.33334C1.83301 8.062 1.83434 7.15934 1.92634 6.47334C2.01634 5.80334 2.18567 5.41667 2.46767 5.13467C2.74967 4.85267 3.13634 4.68334 3.80701 4.59334C4.49234 4.50134 5.39501 4.5 6.66634 4.5H8.66634C9.93767 4.5 10.841 4.50134 11.5263 4.59334C12.1963 4.68334 12.583 4.85267 12.865 5.13467C13.1977 5.46667 13.369 5.93934 13.445 6.83334H13.8883H13.8997ZM6.62901 3.5H8.70367C9.04834 3.5 9.37234 3.5 9.67701 3.502L8.56634 2.76534C8.03301 2.412 7.29967 2.412 6.76634 2.76534L5.65501 3.502C5.96034 3.5 6.28434 3.5 6.62834 3.5"
                                            fill="#4B8700"
                                          />
                                          <path
                                            d="M4 6.16667C3.86739 6.16667 3.74021 6.21935 3.64645 6.31312C3.55268 6.40689 3.5 6.53406 3.5 6.66667C3.5 6.79928 3.55268 6.92646 3.64645 7.02022C3.74021 7.11399 3.86739 7.16667 4 7.16667H6.66667C6.79927 7.16667 6.92645 7.11399 7.02022 7.02022C7.11399 6.92646 7.16667 6.79928 7.16667 6.66667C7.16667 6.53406 7.11399 6.40689 7.02022 6.31312C6.92645 6.21935 6.79927 6.16667 6.66667 6.16667H4Z"
                                            fill="#4B8700"
                                          />
                                          <path
                                            d="M12.6663 9.33334C12.6663 9.51015 12.5961 9.67972 12.4711 9.80474C12.3461 9.92977 12.1765 10 11.9997 10C11.8229 10 11.6533 9.92977 11.5283 9.80474C11.4032 9.67972 11.333 9.51015 11.333 9.33334C11.333 9.15653 11.4032 8.98696 11.5283 8.86193C11.6533 8.73691 11.8229 8.66667 11.9997 8.66667C12.1765 8.66667 12.3461 8.73691 12.4711 8.86193C12.5961 8.98696 12.6663 9.15653 12.6663 9.33334Z"
                                            fill="#4B8700"
                                          />
                                        </svg>

                                        <span>
                                          {job?.pay.rateType === "Range" && (
                                            <>
                                              &#163;{job?.pay.minimum} - &#163;
                                              {job?.pay.maximum}
                                            </>
                                          )}
                                          {job?.pay.rateType === "Fixed" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} (Fixed)
                                            </>
                                          )}

                                          {job?.pay.rateType === "Hourly" && (
                                            <>
                                              {" "}
                                              &#163;
                                              {!job?.pay.maximum
                                                ? job?.pay.minimum
                                                : job?.pay.maximum}{" "}
                                              per hour
                                            </>
                                          )}
                                          {job?.pay.rateType ===
                                            "Hourly Rate" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per hour
                                            </>
                                          )}
                                          {job?.pay.rateType === "Annually" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per year
                                            </>
                                          )}
                                          {job?.pay.rateType === "Yearly" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per year
                                            </>
                                          )}
                                          {job?.pay.rateType === "Monthly" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per month
                                            </>
                                          )}
                                          {job?.pay.rateType === "Weekly" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per week
                                            </>
                                          )}
                                          {job?.pay.rateType === "Per Day" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per day
                                            </>
                                          )}
                                          {job?.pay.rateType ===
                                            "Per Project" && (
                                            <>
                                              {" "}
                                              &#163;{job?.pay.maximum} per
                                              project
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="pagination-controls">
                      <button
                        style={{
                          backgroundColor:
                            customStyles.buttonprevBackgroundColor,
                          color: customStyles.buttonprevTextColor,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonprevHoverBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonprevHoverTextColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonprevBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonprevTextColor;
                        }}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-button"
                      >
                        Previous
                      </button>
                      {visiblePages.map((page, index) => (
                        <button
                          style={{
                            backgroundColor:
                              customStyles.paginationbuttonBackgroundColor,
                            color: customStyles.paginationbuttonTextColor,
                          }}
                          key={index}
                          onClick={() =>
                            page !== "..." && handlePageChange(page)
                          }
                          className={`pagination-button ${
                            currentPage === page ? "active" : ""
                          }`}
                          disabled={page === "..."}
                        >
                          {page}
                        </button>
                      ))}
                      <button
                        style={{
                          backgroundColor:
                            customStyles.buttonnextBackgroundColor,
                          color: customStyles.buttonnextTextColor,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonnextHoverBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonnextHoverTextColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonnextBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonnextTextColor;
                        }}
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-button"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center mt-10">
                  <h2 className="text-xl font-bold">No jobs found</h2>
                  {/* <p>Try refining your search criteria.</p> */}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
      {/* Pagination */}
    </div>
  );
};

export default IframeCode;
